/**
 * Class: Routes
 * Description: This constant holds all of the necessary arrays that are used
 *              when doing route navigation in typescript files.
 */
export class Routes {
  public static LOGIN: string[] = ["/", "login"];
  public static LOGIN_PATH: string = "/login";
  public static isLoginPage(url: string): boolean {
    return url == Routes.LOGIN_PATH;
  }

  public static ADMIN: string[] = ["/", "admin"];
  public static ADMIN_PATH: string = "/admin";
  public static isAdmin(url: string) {
    url == Routes.ADMIN_PATH;
  }
  public static VENUE: string[] = ["/", "venue"];
  public static VENUE_PATH: string = "/venue";
  public static isOwnerDashboard(url: string): boolean {
    return url == Routes.VENUE_PATH;
  }

  public static ORDERS: string[] = ["/", "orders"];
  public static ORDERS_PATH: string = "/orders";
  public static isOrdersPage(url: string) {
    return url == Routes.ORDERS_PATH;
  }

  public static CITIES: string[] = ["/", "admin", "cities"];
  public static CITIES_PATH: string = "/cities";
  public static isCitiesPage(url: string): boolean {
    return url == Routes.CITIES_PATH;
  }

  public static CITY: string[] = ["/", "city"];
  public static CITY_PATH: string = "/city";
  public static isCityPage(url: string): boolean {
    return url == Routes.CITY_PATH;
  }

  public static MANAGE_USERS: string[] = ["/", ""];
  public static MANAGE_USERS_PATH: string = "/manage-users";
  public static isManageUsersPage(url: string): boolean {
    return url == Routes.MANAGE_USERS_PATH;
  }

  public static ADD_PASS: string[] = ["/", "venue", "passes", "add-pass"];
  public static ADD_PASS_PATH: string = "/add-pass";
  public static isAddPassPage(url: string): boolean {
    return url == Routes.ADD_PASS_PATH;
  }


  // public static VENUES: string[] = ["/", "venues"];
  // public static VENUES_PATH: string = "/venues";
  // public static isVenuesPage(url: string): boolean {
  //   return url == Routes.VENUES_PATH;
  // }
}
